import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kmsumtvznisdsaepbtgy.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imttc3VtdHZ6bmlzZHNhZXBidGd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MzY1ODgsImV4cCI6MjA5NDExMjU4OH0.G91Nrdyoe2d_F9qkAOqwBn0_wbzQinekhndrGhXb1Jc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
